module.exports = {"340621100":"濉溪镇","340621101":"韩村镇","340621102":"刘桥镇","340621103":"五沟镇","340621104":"临涣镇","340621105":"双堆集镇","340621106":"铁佛镇","340621107":"南坪镇","340621108":"百善镇","340621109":"孙町镇","340621110":"四铺镇","340621400":"濉溪县经济开发区","340621401":"濉溪县濉芜产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340621.json
// module id = 1082
// module chunks = 0